import React from 'react';
import Terms from '../../../signup/terms';
import './Agreements.css';

const Agreements = () => {
    return (
        <div className="service-agreements-container">
            <div className="service-agreements-wrap">
                <div className="service-agreements-title">Software as a service agreement</div>
                <div className="service-agreements-content">
                    <Terms />
                </div>
            </div>
        </div>
    );
};

export default Agreements;